export const IDEA_ATTACHMENT_MAX_FILES = 5
export const IDEA_ATTACHMENT_MAX_BYTES = 10 * 1024 * 1024 // 10 MB

export const IDEA_ATTACHMENT_EXTENSIONS = [
  '.xlsx',
  '.xls',
  '.pdf',
  '.docx',
  '.jpg',
  '.jpeg',
  '.png',
]

const EXTENSION_SET = new Set(IDEA_ATTACHMENT_EXTENSIONS)

export function getFileExtension(filename) {
  const name = (filename || '').toLowerCase()
  const dot = name.lastIndexOf('.')
  if (dot < 0) return ''
  return name.slice(dot)
}

export function isAllowedIdeaAttachment(file) {
  const ext = getFileExtension(file?.name)
  return EXTENSION_SET.has(ext)
}

export function validateIdeaAttachmentFile(file) {
  if (!file) return 'No file selected'
  if (!isAllowedIdeaAttachment(file)) {
    return `Unsupported file type. Allowed: ${IDEA_ATTACHMENT_EXTENSIONS.join(', ')}`
  }
  if (file.size > IDEA_ATTACHMENT_MAX_BYTES) {
    return `File must be under ${IDEA_ATTACHMENT_MAX_BYTES / (1024 * 1024)} MB`
  }
  if (file.size <= 0) return 'File is empty'
  return null
}

export function validateIdeaAttachmentList(files) {
  if (!files?.length) return null
  if (files.length > IDEA_ATTACHMENT_MAX_FILES) {
    return `Maximum ${IDEA_ATTACHMENT_MAX_FILES} files per idea`
  }
  for (const file of files) {
    const err = validateIdeaAttachmentFile(file)
    if (err) return err
  }
  return null
}

export function getAttachmentKind(mimeType, filename) {
  const ext = getFileExtension(filename)
  if (['.jpg', '.jpeg', '.png'].includes(ext) || (mimeType || '').startsWith('image/')) {
    return 'image'
  }
  if (ext === '.pdf' || mimeType === 'application/pdf') return 'pdf'
  if (['.xlsx', '.xls'].includes(ext)) return 'excel'
  if (ext === '.docx') return 'docx'
  return 'other'
}
